import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconFilePdfColor from './icon-file-pdf-color.vue';

const IconFilePdfColor = Object.assign(_IconFilePdfColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconFilePdfColor.name, _IconFilePdfColor);
  }
});

export default IconFilePdfColor;
